import React from 'react';

import styles from './ExportPanel.module.scss';

import AppearAnimation, {
	AppearAnimationDirection
} from '../animations/AppearAnimation';



type Props = {
	children?: React.ReactNode,
	description?: React.ReactNode,
	title?: React.ReactNode,
};

const ExportPanel: React.FC<Props> = (props) => {
	const {
		children,
		description,
		title,
	} = props;

	return (
		<div className={styles.component}>
			<h3 className={styles.title}>
				{title}
			</h3>

			<AppearAnimation direction={AppearAnimationDirection.Down}>
				<div className={styles.content}>

					<div className={`${styles.text} typo`}>
						<p>
							{description}
						</p>
					</div>
				</div>

				<div className={styles.form}>
					{children}
				</div>
			</AppearAnimation>
		</div>
	);
};



export default ExportPanel;
